import styled from 'styled-components'

export default styled.div`
    margin-bottom: ${({ theme }) =>theme.paddingBox};
    width: 100%;
`
